export default __webpack_public_path__ + "static/media/afternoon-killed.91873209.png";